import { ReactNode, useMemo } from 'react'
import { Navigate } from 'react-router-dom'

import { defineAbilitiesFor } from '@/ability'
import { AbilityContext } from '@/ability/ability-context'
import { RouteNames } from '@/routes'
import { CaseWorker, User } from '@/store/user'

export function AbilityProvider({
  children,
  user,
  caseWorker,
  routeName,
}: {
  children: ReactNode
  user: User
  caseWorker?: CaseWorker
  routeName: RouteNames
}) {
  const ability = useMemo(() => defineAbilitiesFor({ user, caseWorker }), [user, caseWorker])
  // @ts-expect-error Ability type issue
  if (ability.can('accessRoute', routeName.toString())) {
    return <AbilityContext.Provider value={ability}>{children}</AbilityContext.Provider>
  } else {
    window.console.error(`Unauthorized access to route: ${routeName}`)
    // User is authenticated but not authorized for this specific route
    // Redirect to a safe default route
    return <Navigate to={RouteNames.Root} replace />
  }
}
